var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomSanka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.75 186.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#37a59a;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.83,51.4c3.91-1.78,7.91-4.98,11.36-10.78,6.83-11.46,4.6-26.64-9.27-33.65C30.04-.05,16.5,7.16,11.32,19.46c-2.62,6.22-2.82,11.34-1.94,15.54l32.44,16.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 123.74,
    cy: 48.61,
    r: 31.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.72,142.42s.02.08.04.12c1.79,5.8,8.26,8.74,13.87,6.42l37.94-15.68c2.76-1.14,5.85.55,6.41,3.48.55,2.86.35,5.91.35,9.13v40.86h78.42v-46.22c0-1.52,1.23-2.75,2.75-2.75h.85c1.53,0,2.76,1.24,2.76,2.76v46.21h27.62v-67.78c0-15.25-16.6-31.84-31.85-31.84h-57.68c-34.56-6.75-53.81,30.79-63.17,18.15l-16.64-40.75c-.83-1.38-1.78-2.49-2.82-3.38.45-.97.87-1.86,1.23-2.56.93-1.82,2.44-2.32,3.61-2.39,2.68-.14,6.55.02,10.76-1.12l-27.84-14.07c1.58,4.06,4.01,7.08,5.48,9.32.64.97,1.13,2.49.22,4.32-.51,1.03-1.27,2.41-2.08,3.86-2.74.27-5.48,1.39-7.86,3.15-6.13,4.54-6.24,9.61-2.87,19.31l20.51,61.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.47,
    y: -2.2,
    width: 9.28,
    height: 24.9,
    rx: 4.64,
    ry: 4.64,
    transform: "translate(56.11 -118.18) rotate(44.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.65,
    y: 33.56,
    width: 9.28,
    height: 24.92,
    rx: 4.64,
    ry: 4.64,
    transform: "translate(133.48 231.95) rotate(-87.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 180.98,
    y: 13.94,
    width: 9.28,
    height: 24.9,
    rx: 4.64,
    ry: 4.64,
    transform: "translate(229.5 208.66) rotate(-111.63)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSanka);
export default __webpack_public_path__ + "static/media/room_sanka.4ce4c3af0d03b70164f6d00bd9344914.svg";
export { ForwardRef as ReactComponent };